import { render, staticRenderFns } from "./aboutMap.vue?vue&type=template&id=625063a6&scoped=true"
import script from "./aboutMap.vue?vue&type=script&lang=js"
export * from "./aboutMap.vue?vue&type=script&lang=js"
import style1 from "./aboutMap.vue?vue&type=style&index=1&id=625063a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625063a6",
  null
  
)

export default component.exports